import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Modal, ModalBody, ModalFooter, Spinner, Alert } from 'reactstrap';
import { deleteItem, deletLibarary } from './redux/dispatcher';
import deleteImage from '../../assets/img/delete.png'
import libraryReducer from './redux/reducer';
function DeleteModel({ args, libraryId , setIsDeleteModelShow }) {
  const dispatch = useDispatch()
  const [modal, setModal] = useState(true);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);

  const toggle = () => {
    setModal(!modal);
    setIsDeleteModelShow((prevState)=> !prevState)
  };

  const handleDelete = async () => {
    setError(null);
    try {
        dispatch(deletLibarary(libraryId, setLoading, toggle))
    } catch (err) {
      setError('Error occurred while deleting item.');
    } 
  };

  return (
    <div>
      <Modal isOpen={modal} toggle={toggle} {...args}>
        {/* <ModalHeader toggle={toggle}>Delete</ModalHeader> */}
        <ModalBody>
          {error && <Alert color="danger">{error}</Alert>}
          {success && <Alert color="success">Item deleted successfully.</Alert>}
          {!error && !success && (
            <>
            <div className="text-center">
            <img src={deleteImage} alt="" style={{width: '60px'}} />
            <p className="mt-3">Are you sure you want to delete this Library?</p>
          </div>
            </>
          )}
        </ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={handleDelete} disabled={loading || success}>
            {loading ? <Spinner size="sm" /> : 'Delete'}
          </Button>{' '}
          <Button color="secondary" onClick={toggle} disabled={loading}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  );
}

export default DeleteModel;
